var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5659 64.8002C39.2948 64.8002 39.0416 64.727 38.8064 64.5988L36.4015 63.1525C36.0397 62.951 36.2206 62.8778 36.3292 62.8412C36.8173 62.6764 36.9078 62.6397 37.4141 62.3469C37.4684 62.3102 37.5408 62.3285 37.5949 62.3651L39.4395 63.482C39.5118 63.5186 39.6022 63.5186 39.6563 63.482L46.8716 59.2525C46.9439 59.2159 46.9801 59.1426 46.9801 59.0512V50.6106C46.9801 50.5189 46.9439 50.4459 46.8716 50.4091L39.6563 46.198C39.584 46.1613 39.4936 46.1613 39.4395 46.198L32.2242 50.4091C32.152 50.4457 32.1157 50.5373 32.1157 50.6105V59.051C32.1157 59.1244 32.152 59.2158 32.2242 59.2525L34.1953 60.406C35.2623 60.9552 35.9313 60.3144 35.9313 59.6736V51.3428C35.9313 51.2331 36.0217 51.1231 36.1483 51.1231H37.0705C37.1791 51.1231 37.2875 51.2147 37.2875 51.3428V59.6736C37.2875 61.12 36.5099 61.9623 35.1537 61.9623C34.7378 61.9623 34.4124 61.9623 33.49 61.5045L31.5914 60.406C31.1212 60.1314 30.8319 59.6186 30.8319 59.0694V50.6288C30.8319 50.0796 31.1212 49.5668 31.5914 49.2923L38.8064 45.0628C39.2586 44.8065 39.8735 44.8065 40.3255 45.0628L47.5406 49.2923C48.0108 49.5668 48.3002 50.0796 48.3002 50.6288V59.0694C48.3002 59.6186 48.0108 60.1314 47.5406 60.406L40.3255 64.6354C40.0904 64.7454 39.8191 64.8002 39.5659 64.8002ZM41.7902 58.9962C38.6257 58.9962 37.9747 57.5315 37.9747 56.2865C37.9747 56.1765 38.0651 56.0667 38.1917 56.0667H39.132C39.2405 56.0667 39.3309 56.1399 39.3309 56.2499C39.4756 57.2202 39.8915 57.6962 41.8083 57.6962C43.3272 57.6962 43.9784 57.3483 43.9784 56.5244C43.9784 56.0484 43.7974 55.7006 41.4286 55.4625C39.4575 55.261 38.2278 54.8217 38.2278 53.2288C38.2278 51.7457 39.4576 50.8668 41.519 50.8668C43.8335 50.8668 44.9729 51.6725 45.1176 53.43C45.1176 53.4851 45.0995 53.54 45.0633 53.5949C45.027 53.6315 44.9729 53.6681 44.9186 53.6681H43.9783C43.8878 53.6681 43.7974 53.5949 43.7794 53.5034C43.5624 52.4964 43.0018 52.1668 41.519 52.1668C39.8554 52.1668 39.6563 52.7528 39.6563 53.1921C39.6563 53.7231 39.8915 53.8878 42.1338 54.1808C44.358 54.4738 45.4069 54.8949 45.4069 56.4694C45.3888 58.0807 44.0869 58.9962 41.7902 58.9962Z",
    fill: "#539E43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.179 31.7886C17.179 31.4591 16.9982 31.1476 16.7089 30.9829L9.04161 26.5155C8.91488 26.4421 8.77031 26.4055 8.62574 26.3871H8.5533C8.40872 26.3871 8.264 26.4421 8.13742 26.5155L0.470168 30.9829C0.180713 31.1476 0 31.4589 0 31.7886L0.0181496 43.7994C0.0181496 43.9642 0.108584 44.1289 0.253155 44.2023C0.397882 44.2938 0.578596 44.2938 0.70533 44.2023L5.26228 41.5657C5.55158 41.401 5.73245 41.0897 5.73245 40.7601V35.1391C5.73245 34.8096 5.91316 34.4983 6.20261 34.3336L8.13742 33.1983C8.28215 33.1068 8.44487 33.07 8.60759 33.07C8.77031 33.07 8.93303 33.1068 9.05976 33.1983L10.9946 34.3336C11.284 34.4983 11.4647 34.8095 11.4647 35.1391V40.7601C11.4647 41.0897 11.6456 41.401 11.9349 41.5657L16.4919 44.2023C16.5623 44.2472 16.6437 44.271 16.7269 44.271C16.8101 44.271 16.8916 44.2472 16.962 44.2023C17.1067 44.1289 17.1972 43.9642 17.1972 43.7994L17.179 31.7886ZM54.0325 15.2552C53.8879 15.1819 53.7071 15.1819 53.5803 15.2552C53.4358 15.3468 53.3453 15.4932 53.3453 15.6579V27.5591C53.3453 27.6689 53.2912 27.7787 53.1826 27.852C53.0742 27.9068 52.9656 27.9068 52.8572 27.852L50.9404 26.7352C50.7998 26.6542 50.6409 26.6116 50.4792 26.6116C50.3175 26.6116 50.1585 26.6542 50.018 26.7352L42.3508 31.221C42.0615 31.3857 41.8806 31.697 41.8806 32.0265V40.9797C41.8806 41.3092 42.0615 41.6207 42.3508 41.7854L50.018 46.2712C50.1585 46.3522 50.3175 46.3948 50.4792 46.3948C50.6409 46.3948 50.7998 46.3522 50.9404 46.2712L58.6076 41.7854C58.8969 41.6207 59.0778 41.3094 59.0778 40.9797V18.6607C59.0778 18.3128 58.8969 18.0017 58.6076 17.8368L54.0325 15.2552ZM53.3273 38.032C53.3273 38.1236 53.2912 38.1968 53.2188 38.2334L50.5968 39.7713C50.5601 39.7894 50.5199 39.7988 50.4792 39.7988C50.4384 39.7988 50.3982 39.7894 50.3616 39.7713L47.7396 38.2334C47.6672 38.1968 47.631 38.1052 47.631 38.032V34.956C47.631 34.8644 47.6672 34.7912 47.7396 34.7547L50.3616 33.2166C50.3982 33.1985 50.4384 33.1891 50.4792 33.1891C50.5199 33.1891 50.5601 33.1985 50.5968 33.2166L53.2188 34.7547C53.2912 34.7911 53.3273 34.8828 53.3273 34.956V38.032ZM79.5478 34.8828C79.8373 34.7181 80 34.4068 80 34.0771V31.8984C80 31.5689 79.8191 31.2576 79.5478 31.0928L71.9349 26.6254C71.7943 26.5444 71.6354 26.5018 71.4737 26.5018C71.312 26.5018 71.1531 26.5444 71.0125 26.6254L63.3453 31.111C63.0558 31.2758 62.8751 31.5871 62.8751 31.9166V40.8699C62.8751 41.1994 63.056 41.5107 63.3453 41.6755L70.9582 46.0697C71.2477 46.2345 71.5913 46.2345 71.8626 46.0697L76.4737 43.4701C76.6184 43.3967 76.7088 43.232 76.7088 43.0672C76.7088 42.9024 76.6184 42.7377 76.4737 42.6643L68.7703 38.1786C68.6255 38.087 68.5351 37.9406 68.5351 37.7759V34.9745C68.5351 34.8098 68.6255 34.645 68.7703 34.5717L71.1752 33.1801C71.2457 33.1353 71.3271 33.1115 71.4103 33.1115C71.4935 33.1115 71.575 33.1353 71.6454 33.1801L74.0505 34.5717C74.1953 34.6632 74.2856 34.8096 74.2856 34.9745V37.1716C74.2856 37.3364 74.376 37.5012 74.5207 37.5743C74.5911 37.6192 74.6726 37.643 74.7558 37.643C74.839 37.643 74.9205 37.6192 74.9909 37.5743L79.5478 34.8828Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3561 34.4616C71.383 34.4437 71.4144 34.4341 71.4465 34.4341C71.4787 34.4341 71.5101 34.4437 71.537 34.4616L73.0018 35.3221C73.0559 35.3589 73.0921 35.4137 73.0921 35.4869V37.2081C73.0921 37.2813 73.0561 37.3362 73.0018 37.3728L71.537 38.2334C71.5101 38.2513 71.4787 38.2608 71.4465 38.2608C71.4144 38.2608 71.383 38.2513 71.3561 38.2334L69.8915 37.3728C69.8372 37.3362 69.801 37.2813 69.801 37.2081V35.487C69.801 35.4137 69.837 35.3587 69.8915 35.3223L71.3561 34.4616Z",
    fill: "#539E43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6311 31.111L29.982 26.662C29.9068 26.6236 29.828 26.5929 29.7468 26.5704L21.1754 41.4377C21.2464 41.5255 21.3321 41.5999 21.4287 41.6574L29.0778 46.1066C29.2948 46.2348 29.548 46.2714 29.783 46.198L37.8301 31.2943C37.7758 31.2211 37.7034 31.1658 37.6311 31.111Z",
    fill: "url(#paint0_linear_148_59)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8246 25.0323L28.7162 25.0873H28.8608L28.8246 25.0323Z",
    fill: "url(#paint1_linear_148_59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6492 41.6389C37.8663 41.5107 38.029 41.291 38.1014 41.0531L29.7105 26.552C29.4935 26.5155 29.2584 26.5337 29.0596 26.6618L21.4647 31.0928L29.6562 46.2163C29.7754 46.1965 29.8911 46.1595 29.9998 46.1065L37.6491 41.6391L37.6492 41.6389Z",
    fill: "url(#paint2_linear_148_59)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3546 41.4925L38.3003 41.401V41.5291L38.3546 41.4925Z",
    fill: "url(#paint3_linear_148_59)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6492 41.6389L30.0181 46.0881C29.9104 46.1437 29.7943 46.181 29.6745 46.198L29.8193 46.4726L38.2821 41.5109V41.401L38.0651 41.0347C38.029 41.291 37.8663 41.5107 37.6492 41.6389Z",
    fill: "url(#paint4_linear_148_59)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6492 41.6389L30.0181 46.0881C29.9104 46.1437 29.7943 46.181 29.6745 46.198L29.8193 46.4726L38.2821 41.5109V41.401L38.0651 41.0347C38.029 41.291 37.8663 41.5107 37.6492 41.6389Z",
    fill: "url(#paint5_linear_148_59)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_59",
    x1: 34.6216,
    y1: 42.564,
    x2: 98.2214,
    y2: -22.4288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_148_59",
    x1: -3531.02,
    y1: 21.8614,
    x2: 4262.34,
    y2: 21.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_148_59",
    x1: -3.5112,
    y1: 39.9987,
    x2: 81.1992,
    y2: 39.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_148_59",
    x1: -7771.02,
    y1: 33.1603,
    x2: 22.3439,
    y2: 33.1603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_148_59",
    x1: -83.0888,
    y1: 40.1366,
    x2: 80.6376,
    y2: 40.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_148_59",
    x1: 40.9172,
    y1: 29.5569,
    x2: 36.346,
    y2: 53.2137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.3db8cec7467f4e2ec3b6c708fcf93a03.svg";
export { ForwardRef as ReactComponent };